import { UNASSIGNED_QHP_ID } from '@/constants/visit';
import { ReturnComponent } from '@/utils/reactTypes';
import { Person, PersonOff } from '@mui/icons-material';
import { Box } from '@mui/material';

import { AxleChip } from '../displayFields/chips';
import { HorizontalStack } from '../utils/linearLayouts';
import { IClinicianOption } from './OptionalClinicianSelector';

// Renders the logo or fallback icon of a QHP or the "Unassigned" option.
export const ClinicianOptionLabel = ({
    option,
}: {
    option: IClinicianOption | null;
}): ReturnComponent => {
    if (!option || option.id === UNASSIGNED_QHP_ID) {
        return (
            <Box display='flex'>
                <PersonOff /> <Box ml={1}>Unassigned</Box>
            </Box>
        );
    }
    const name = option.firstName + (option.lastName ? ' ' + option.lastName : '');
    return (
        <HorizontalStack sx={{ justifyContent: 'space-between' }}>
            <HorizontalStack spacing={1}>
                {option.logoUrl ? (
                    <Box
                        component='img'
                        src={option.logoUrl}
                        alt={name}
                        style={{
                            objectFit: 'contain',
                            width: '1.5em',
                            height: '1.5em',
                        }}
                    />
                ) : (
                    <Person />
                )}{' '}
                <Box>{name}</Box>
            </HorizontalStack>
            {option.licenses && option.licenses.length > 0 ? (
                <div>
                    {option.licenses.map((license) => (
                        <AxleChip variant='outlined' key={license} label={license} size='small' />
                    ))}
                </div>
            ) : null}
        </HorizontalStack>
    );
};
